export default "__VITE_ASSET__BWqLXSjG__"